import React from 'react';

const BillingSummary = () => {
  const summaryData = [
    { 
      title: 'Total facturado este mes', 
      value: '$1,240,000 COP', 
      change: '+12%', 
      icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      color: 'bg-cyan-100 text-cyan-600'
    },
    { 
      title: 'Servicio más vendido', 
      value: 'Guardería día', 
      change: '45 ventas', 
      icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
      color: 'bg-purple-100 text-purple-600'
    },
    { 
      title: 'Clientes por pagar', 
      value: '5 clientes', 
      change: '$320,000 COP', 
      icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
      color: 'bg-orange-100 text-orange-600'
    },
    { 
      title: 'Último pago', 
      value: 'Ayer', 
      change: '$60,000 COP', 
      icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
      color: 'bg-green-100 text-green-600'
    }
  ];

  return (
    <div className="ml-64 p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {summaryData.map((item, index) => (
        <div key={index} className="bg-white rounded-xl shadow-sm p-6">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-gray-500">{item.title}</p>
              <p className="text-2xl font-bold mt-1">{item.value}</p>
              <span className={`text-xs px-2 py-1 rounded-full ${item.color} mt-2 inline-block`}>
                {item.change}
              </span>
            </div>
            <div className={`p-2 rounded-lg ${item.color.replace('text', 'bg').split(' ')[0]} bg-opacity-20`}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
              </svg>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BillingSummary;

// DONE